import { compareTwoValue, generateString } from 'designer/component/action/Data'
import { getFormGroup } from 'designer/component/action/FormGroup'
import { setRequestFormData } from '../Request'
import objectPath from 'object-path'
import cloneDeep from 'clone-deep'

export const addTableToTable = ({ action, data, designContext }) => {
  const { getCurrentUi } = designContext
  let { formData } = data
  let {
    tableKey,
    sourceTableKey,
    mapColumn = [],
    isFilterDuplicatedId,
  } = action
  if (!tableKey || !sourceTableKey) {
    return {
      status: 500,
      message: 'Not found table',
      data: null,
    }
  }
  let sourceUi = getCurrentUi(sourceTableKey)
  let sourceData =
    objectPath.get(formData, sourceUi.key) ||
    objectPath.get(formData, sourceUi.name) ||
    []
  let tableUi = getCurrentUi(tableKey)
  let tableData =
    objectPath.get(formData, tableUi.key) ||
    objectPath.get(formData, tableUi.name) ||
    []
  sourceData = cloneDeep(sourceData)
  tableData = cloneDeep(tableData)
  let startSeq = tableData.length + 1
  let columnRefId = tableUi?.loadData?.columnRefId
  sourceData.map((data) => {
    let genId = generateString(10)
    mapColumn.forEach((column) => {
      let sourceField = column.bulkKey
      let destinationField = column.value
      let sourceValue = objectPath.get(data, sourceField)
      objectPath.set(data, destinationField, sourceValue)
      objectPath.del(data, sourceField)
    })
    objectPath.set(data, '@genId', 'id-' + genId)
    objectPath.set(data, 'seq', startSeq)
    objectPath.set(data, 'tableData.no', startSeq)
    startSeq++
    return data
  })
  if (isFilterDuplicatedId) {
    sourceData.forEach((sourceItem) => {
      let sourceId = objectPath.get(sourceItem, columnRefId)
      let foundRow = tableData.find((rowItem) => {
        let destinationId = objectPath.get(rowItem, columnRefId)
        let isDup = compareTwoValue('equalValue', sourceId, destinationId)
        return isDup
      })
      if (foundRow) return
      tableData.push(sourceItem)
    })
  } else {
    sourceData.forEach((sourceItem) => {
      tableData.push(sourceItem)
    })
  }
  return tableData
}

export const addSingleToTable = ({ action, data, designContext }) => {
  const { getCurrentUi } = designContext
  const allFormGroup = getFormGroup(designContext)
  let { formData } = data
  let { formDataKey, tableKey, mapColumn = [], isFilterDuplicatedId } = action
  if (!tableKey) {
    return {
      status: 500,
      message: 'Not found table',
      data: null,
    }
  }
  let tableUi = getCurrentUi(tableKey)
  let tableData = objectPath.get(formData, tableUi.key)
  tableData = Array.isArray(tableData) ? [...tableData] : []
  let columnRefId = tableUi?.loadData?.columnRefId
  let form = allFormGroup.find((form) => form.key === formDataKey)
  if (!formDataKey || !form) {
    return {
      status: 404,
      message: 'Not found form data',
      data: {},
    }
  }
  let genId = generateString(10)
  let seq = tableData.length + 1
  let requestBody = {
    '@genId': 'id-' + genId,
    seq: seq,
    tableData: { no: seq },
  }
  requestBody = setRequestFormData({
    form,
    requestBody,
    designContext,
    data,
  })
  mapColumn.forEach(({ bulkKey, value }) => {
    let requestValue = objectPath.get(requestBody, bulkKey)
    objectPath.set(requestBody, value, requestValue)
    objectPath.del(requestBody, bulkKey)
  })

  if (isFilterDuplicatedId) {
    let sourceId = objectPath.get(requestBody, columnRefId)
    let foundRow = tableData.find((rowItem) => {
      let destinationId = objectPath.get(rowItem, columnRefId)
      let isDup = compareTwoValue('equalValue', sourceId, destinationId)
      return isDup
    })
    if (foundRow) return tableData
  }
  return tableData.concat(requestBody)
}

export const addBulkToTable = ({ action, data, designContext }) => {
  const { jsonForm, getCurrentUi } = designContext
  let { formData } = data
  const allBulkGroup = jsonForm?.bulkGroup || []
  let { bulkDataKey, tableKey, mapColumn = [] } = action
  if (!tableKey) {
    return {
      status: 500,
      message: 'Not found table',
      data: null,
    }
  }
  let tableUi = getCurrentUi(tableKey)
  let { tableColumn = [] } = tableUi
  let tableData = objectPath.get(formData, tableUi.key)
  tableData = Array.isArray(tableData) ? [...tableData] : []
  if (!bulkDataKey) {
    return {
      status: 500,
      message: 'Not found bulk data',
      data: null,
    }
  }
  let bulkGroup = allBulkGroup.find(({ key }) => key === bulkDataKey)
  let { bulkTable = [] } = bulkGroup
  let bulkRequest = []
  let bulkKey = bulkGroup?.mainBulk?.key
  let bulkUi = getCurrentUi(bulkKey)
  let bulkName = bulkUi.name
  let bulkData = objectPath.get(formData, bulkKey)
  if (!bulkData) {
    return {
      status: 500,
      message: 'Not found added data',
      data: null,
    }
  }
  if (!Array.isArray(bulkData)) {
    bulkData = [bulkData]
  }
  let mapTag = jsonForm.schema.mapTag
  let mapKey = jsonForm.schema.mapKey
  let subList = Object.keys(mapTag).filter((key) => {
    let tag = mapTag[key]
    let fullKey = mapKey[key]
    return (
      tag === 'list' && key !== bulkKey && fullKey.split('.').includes(bulkKey)
    )
  })
  console.log('bulkData', bulkData)
  bulkData.forEach((value) => {
    if (action?.isFilterCheckedValue) {
      subList.forEach((key) => {
        let ui = getCurrentUi(key)
        let { name, loadItem } = ui
        if (!objectPath.get(value, name)) return
        const methodKey = loadItem.method
          ? loadItem.method.toLocaleLowerCase()
          : ''
        const dataMethod = methodKey
          ? objectPath.get(loadItem, `${methodKey}`)
          : {}
        if (dataMethod?.isFilterCheckedValue) {
          let subData = objectPath.get(value, name)
          if (subData && Array.isArray(subData)) {
            let filterChecked = subData.filter((value) =>
              objectPath.get(value, '@isChecked'),
            )
            objectPath.set(value, name, filterChecked)
          }
        }
      })
    }
    let itemRequest = {}
    if (value && typeof value === 'object') {
      itemRequest = value
    } else {
      objectPath.set(itemRequest, bulkName, value)
    }
    if (objectPath.has(formData, `@${bulkKey}`)) {
      let foundValue
      if (bulkUi.tagname === 'select') {
        let selectValue = objectPath.get(formData, `@${bulkKey}`)
        let optionValue = objectPath.get(bulkUi, [
          bulkUi.valueType,
          'optionValue',
        ])
        foundValue = selectValue.find(
          (option) => objectPath.get(option, optionValue) === value,
        )
      }
      if (foundValue) {
        objectPath.set(itemRequest, `@${bulkName}`, foundValue)
      }
    }
    bulkTable.forEach((rowItem) => {
      let ui = getCurrentUi(rowItem.key)
      let parentElements = ui.elements
      if (rowItem.isParent) {
        let rowValue = objectPath.get(formData, ui.name)
        objectPath.set(itemRequest, ui.name, rowValue)
      } else {
        if (rowItem.isArray) {
          let { bulkChild = [] } = rowItem
          let foundParent = parentElements.find(({ name }) => {
            let bulkId = objectPath.get(formData, `@${name}.@${bulkName}`)
            return bulkId === value
          })
          if (foundParent) {
            bulkChild.forEach((childItem) => {
              let childUi = getCurrentUi(childItem.value)
              let parentData = objectPath.get(formData, `@${foundParent.name}`)
              let rowValue = objectPath.get(parentData, childUi.name)
              objectPath.set(itemRequest, childUi.name, rowValue)

              if (childUi.tagname === 'checkboxGroup') {
                let checkList = objectPath.get(
                  parentData,
                  `@checkList.${childUi.key}`,
                )
                if (checkList) {
                  let itemList = []
                  Object.keys(checkList).forEach((key) => {
                    let value = checkList[key]
                    if (value) {
                      itemList.push(value)
                    }
                  })
                  objectPath.set(itemRequest, `@${childUi.name}`, itemList)
                }
              }
            })
          }
        }
      }
    })
    tableColumn.forEach(({ field, mapOther, defaultValue, detailColumn }) => {
      if (objectPath.has(itemRequest, `@${field}`)) {
        if (mapOther) {
          mapOther.forEach((other) => {
            let otherValue = objectPath.get(
              itemRequest,
              `@${field}.${other.value}`,
            )
            objectPath.set(itemRequest, other.field, otherValue)
          })
        }
      }
      if (!objectPath.has(itemRequest, field)) {
        objectPath.set(itemRequest, field, defaultValue)
      }
      if (detailColumn) {
        let subRowData = objectPath.get(itemRequest, field) || []
        detailColumn.forEach((subItem) => {
          let subField = subItem.field
          let defaultValue = subItem.defaultValue
          subRowData.map((subData) => {
            if (objectPath.get(subData, subField) === undefined) {
              objectPath.set(subData, subField, defaultValue)
            }
            return subData
          })
        })
        objectPath.set(itemRequest, field, subRowData)
      }
    })
    mapColumn.forEach((column) => {
      let bulkValue = objectPath.get(value, column.bulkKey)
      objectPath.set(itemRequest, column.value, bulkValue)
    })

    let genId = generateString(10)
    bulkRequest.push({ ...itemRequest, '@genId': 'id-' + genId })
  })
  return tableData.concat(bulkRequest)
}

export const addMultiSelectToTable = ({ action, data, designContext }) => {
  const { getCurrentUi } = designContext
  const allFormGroup = getFormGroup(designContext)
  let { formData } = data
  let { formDataKey, tableKey, selectKey, mapSelectValue } = action
  let tableData = []
  if (!tableKey) {
    return tableData
  }
  let tableUi = getCurrentUi(tableKey)
  let selectUi = getCurrentUi(selectKey)
  if (!tableUi?.key || !selectUi?.key) return tableData
  tableData = objectPath.get(formData, tableKey)
  tableData = Array.isArray(tableData) ? [...tableData] : []
  let selectValue = objectPath.get(formData, selectKey)

  let form = allFormGroup.find((form) => form.key === formDataKey)
  if (!formDataKey || !form) {
    return tableData
  }
  let { valueType, valueJoin = '' } = selectUi
  let optionValueKey =
    selectUi.optionValueKey ||
    objectPath.get(selectUi, [selectUi.valueType, 'optionValue'])
  let selectArray = []
  if (valueType === 'string' && selectValue) {
    selectArray = selectValue.split(valueJoin)
  } else {
    selectArray = selectValue
  }

  if (Array.isArray(selectArray)) {
    selectArray.forEach((value) => {
      let genId = generateString(10)
      let requestBody = { '@genId': 'id-' + genId }
      requestBody = setRequestFormData({
        form,
        requestBody,
        designContext,
        data,
      })
      let mapValue = value
      if (value && typeof value === 'object') {
        if (optionValueKey) {
          mapValue = objectPath.get(value, optionValueKey)
        } else if (objectPath.get(value, 'value')) {
          mapValue = objectPath.get(value, 'value')
        } else if (objectPath.get(value, 'label')) {
          mapValue = objectPath.get(value, 'label')
        }
      }
      objectPath.set(requestBody, mapSelectValue, mapValue)
      if (value && typeof value === 'object') {
        objectPath.set(requestBody, `@${mapSelectValue}`, value)
      }
      let rowData = { '@genId': objectPath.get(requestBody, '@genId') }
      let tableColumn = tableUi?.tableColumn || []
      tableColumn.forEach(({ field, defaultValue }) => {
        if (!field) return
        let rowValue = objectPath.get(requestBody, field)
        if (rowValue === undefined) {
          rowValue = defaultValue
        }
        if (rowValue && typeof rowValue === 'object') {
          rowValue =
            objectPath.get(rowValue, 'value') ||
            objectPath.get(rowValue, 'label')
        }
        objectPath.set(rowData, field, rowValue)
      })
      tableData.push(rowData)
    })
  }

  return tableData
}
